import { ObjectValues } from 'src/types/utils';

export const ORDER_PATH_PARAMS = {
  ALL: 'all',
  OPEN: 'open',
  NATIVE: ':type',
} as const;

export type OrderTypes = ObjectValues<typeof ORDER_PATH_PARAMS>;

export interface TradePageParams {
  pair?: string;
}

export const PATHS = {
  default: () => '/',
  walletAnalytics: () => '/wallet-analytics',
  // trade: ({ pair }: TradePageParams = {}) => {
  //   if (pair === undefined) {
  //     return '/trade/:pair?';
  //   }

  //   return `/trade/${pair}`;
  // },
  trade: (getQueryParams?: string) => `/trade${getQueryParams ? `?${getQueryParams}` : ''}`,
  swap: () => '/swap',
  portfolio: () => '/portfolio',
  liquidityPool: () => '/vmm',
  settings: () => '/settings',
  referrals: () => '/referrals',
  points: () => '/points',
  api: () => '/market-api',
  event: () => '/events',
  tradingCompetition: () => '/competition',
  tradingLeaderboard: () => '/points',
  orders: (type: OrderTypes = ORDER_PATH_PARAMS.NATIVE) => `/orders/${type}`,
  admin: () => '/admin',
  announcements: () => '/announcements',
  announcementDetail: (id: string) => `/announcements/${id}`,
};
